
function TermsPage() {
    return (
        <div className="terms">
            <div className="container">
                <div className="termsMain">
                    <h2>Terms & Conditions</h2>
                    <p>Welcome to Neethu’s Academy! By using our platform, you agree to the following terms and conditions. Please read them carefully as they govern your access and use of our services, including any courses, resources, or features offered.</p>
                    <div className="termsList">
                        <h3>1. Acceptance of Terms</h3>
                        <p>By accessing or using our platform, you agree to comply with these Terms & Conditions. If you do not agree to any part of these terms, you must discontinue using our services.</p>
                    </div>
                    <div className="termsList">
                        <h3>2. Eligibility</h3>
                        <p>By accessing or using our platform, you agree to comply with these Terms & Conditions. If you do not agree to any part of these terms, you must discontinue using our services.</p>
                        <ul>
                            <li>
                                <div className="icon"></div>
                                <h5>You must be at least 18 years old or have parental/guardian consent to use our platform.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5>You agree to provide accurate, complete, and up-to-date information during registration or while using our services.</h5>
                            </li>
                        </ul>
                    </div>
                    <div className="termsList">
                        <h3>3. User Responsibilities</h3>
                        <ul>
                            <li>
                                <div className="icon"></div>
                                <h5>You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5>You agree not to:</h5>
                            </li>
                            <ul>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Use the platform for unlawful purposes or violate any applicable laws.</h5>
                                </li>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Share copyrighted course materials or other proprietary content without permission.</h5>
                                </li>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Attempt to gain unauthorized access to the platform or disrupt its functionality.</h5>
                                </li>
                            </ul>
                        </ul>
                    </div>
                    <div className="termsList">
                        <h3>4. Services and Payments</h3>
                        <div className="termsListBox">
                            <h4>a. Services</h4>
                            <ul>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Neethu's Academy provides educational resources and courses for language proficiency and nursing exams, including OET, IELTS, PTE, TOEFL, and NCLEX-RN preparation.</h5>
                                </li>
                                <li>
                                    <div className="icon"></div>
                                    <h5>The availability of services may be subject to changes, including course schedules and content updates.</h5>
                                </li>
                            </ul>
                        </div>
                        <div className="termsListBox">
                            <h4>b. Payments</h4>
                            <ul>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Payments for courses or services must be made through authorized payment gateways.</h5>
                                </li>
                                <li>
                                    <div className="icon"></div>
                                    <h5>All fees are non-refundable unless otherwise stated in a specific refund policy.</h5>
                                </li>
                            </ul>
                        </div>
                        <div className="termsListBox">
                            <h4>c. Subscription or Enrollment</h4>
                            <ul>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Enrolling in a course grants you a non-transferable, limited license to access the content solely for personal use.</h5>
                                </li>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Unauthorized sharing or distribution of course materials is strictly prohibited.</h5>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="termsList">
                        <h3>5. Intellectual Property</h3>
                        <ul>
                            <li>
                                <div className="icon"></div>
                                <h5>All content on the platform, including course materials, videos, images, text, and logos, is the property of Neethu's Academy or its licensors.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5>You may not reproduce, modify, distribute, or sell any content without prior written permission.</h5>
                            </li>
                        </ul>
                    </div>
                    <div className="termsList">
                        <h3>6. Limitation of Liability</h3>
                        <ul>
                            <li>
                                <div className="icon"></div>
                                <h5>Neethu’s Academy is not responsible for any direct, indirect, or incidental damages resulting from:</h5>
                            </li>
                            <ul>
                                <li>
                                    <div className="icon"></div>
                                    <h5>The use or inability to use the platform.</h5>
                                </li>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Unauthorized access to your account or personal data.</h5>
                                </li>
                            </ul>
                            <li>
                                <div className="icon"></div>
                                <h5>While we strive to ensure accurate and up-to-date information, we make no guarantees regarding the completeness or reliability of the content.</h5>
                            </li>
                        </ul>
                    </div>
                    <div className="termsList">
                        <h3>7. Termination</h3>
                        <p>We reserve the right to suspend or terminate your access to the platform at any time without notice if you violate these terms. Upon termination:</p>
                        <ul>
                            <li>
                                <div className="icon"></div>
                                <h5>You must cease using the platform and its content immediately.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5>Any outstanding fees or obligations remain your responsibility.</h5>
                            </li>
                        </ul>
                    </div>
                    <div className="termsList">
                        <h3>8. Changes to the Terms</h3>
                        <p>We may update these Terms & Conditions periodically. Continued use of the platform after changes are made constitutes your acceptance of the updated terms.</p>
                    </div>
                    <div className="termsList">
                        <h3>9. Governing Law</h3>
                        <p>These Terms & Conditions are subject to applicable laws and regulations. Any disputes will be subject to the exclusive jurisdiction of the courts in that jurisdiction.</p>
                    </div>
                    <div className="termsList">
                        <h3>10. Contact Us</h3>
                        <p>If you have any questions or concerns about these Terms & Conditions, please contact us at:</p>
                        <p>Email: <a href="mailto:hr@neethusacademy.com">hr@neethusacademy.com</a></p>
                        <p>Phone: <a href="tel:+919747944374">+91 9747 944 374</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsPage;
